import { hourMs, minuteMs } from "../../timeConstants.js";

/** Identifies Gen 4 block firmware v14+, which uses a shorter network test duration. */
export const GEN4_V14_PLUS_NETWORK_TEST_VERSION_SELECTOR = "4.block.*.*.14+";

/** Network test duration for Sprout and Gen 4 pre-v14 devices. */
export const NETWORK_TEST_DURATION_MS = 4 * hourMs;

/** Network test duration for Gen 4 v14+ devices (10 minutes, vs. 4 hours for others). */
export const GEN4_V14_PLUS_NETWORK_TEST_DURATION_MS = 10 * minuteMs;
